package tables.placementCat

import emotion.react.css
import entities.Ad
import kotlinx.browser.window
import models.CategoryModel
import models.PlacementCatModel
import org.w3c.fetch.RequestInit
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.table
import react.dom.html.ReactHTML.tbody
import react.dom.html.ReactHTML.td
import react.dom.html.ReactHTML.th
import react.dom.html.ReactHTML.thead
import react.dom.html.ReactHTML.tr
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.BorderCollapse
import web.cssom.Color
import web.cssom.TextAlign
import web.cssom.px
import web.html.InputType

external interface PlacementCatProps : Props

val PlacementCatTable = FC<PlacementCatProps> {

    val (placements, setPlacements) = useState(emptyList<PlacementCatModel>())
    var categoryName by useState("")
    var isModalOpenUpdate: PlacementCatModel? by useState(null)
    var isModalOpenCreate by useState(false)
    val (categories, setCategories) = useState(emptyList<CategoryModel>())
    val (ads, setAds) = useState(emptyList<Ad>())

    fun loadAds() {
        window.fetch(urlAddress + "api/ads", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    Ad(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.message as? String ?: ""
                    )
                }
                setAds(newResultList)
            }
    }

    useEffect(ads.isEmpty()) {
        loadAds()
    }

    fun loadCategories() {
        window.fetch(urlAddress + "api/category", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    CategoryModel(
                        it.id as? Int ?: 0,
                        it.name as? String ?: "",
                        it.parent as? String ?: "",
                        it.iscategory as? Boolean ?: false,
                        it.parent as? Boolean ?: false
                    )
                }
                setCategories(newResultList)
            }
    }

    useEffect(categories.isEmpty()) {
        loadCategories()
    }

    fun loadPlacements() {
        window.fetch(urlAddress + "api/placement", RequestInit(
            method = "GET",
            headers = web.http.Headers().apply {
                append("Authorization", "Bearer $token")
            }
        ))
            .then { response -> response.json() }
            .then { data ->
                val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                    PlacementCatModel(
                        it.id as? Int ?: 0,
                        it.category as? String ?: "",
                        it.ad as? String ?: ""
                    )
                }
                setPlacements(newResultList)
            }
    }

    useEffect(placements.isEmpty()) {
        loadPlacements()
    }

    UpdatePlacementCatModal {
        placementCatModel = isModalOpenUpdate
        listCat = categories
        listAd = ads
        onClose = {
            isModalOpenUpdate = null
        }
        onUpdate = {
            loadPlacements()
        }
    }

    CreatePlacementCatModal {
        isOpen = isModalOpenCreate
        listCat = categories
        listAd = ads
        onClose = {
            isModalOpenCreate = false
        }
        onUpdate = {
            loadPlacements()
        }
    }

    div {
        div {
            +"Введите наименование Категории:"
            input {
                css {
                    fontSize = 14.px
                }
                value = categoryName
                type = InputType.text
                onChange = { event ->
                    categoryName = event.target.value
                }
            }
            button {
                +"Добавить"
                onClick = {
                    isModalOpenCreate = true
                }
            }
        }

        table {
            border = 1
            css {
                borderColor = Color("#000")
                borderCollapse = BorderCollapse.collapse
                textAlign = TextAlign.center
            }
            thead {
                tr {
                    th { +"Категория" }
                    th { +"Реклама" }
                    th { +"Действие" }
                }
            }
            tbody {
                placements.filter { it.category.lowercase().contains(categoryName.lowercase()) }.forEach { item ->
                    tr {
                        td { +item.category }
                        td { +item.ad }
                        td {
                            button {
                                css {
                                    margin = 5.px
                                    marginBottom = 5.px
                                    fontSize = 14.px
                                }
                                +"✏️"
                                onClick = {
                                    isModalOpenUpdate = item
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

